import { Component } from '@angular/core';
import { MetaDataService } from '../metadata.service';

@Component({
  selector: 'tea-shop-fe-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css'],
  standalone: false
})
export class HomeComponent {
  constructor(private metaDataService: MetaDataService) {
    this.metaDataService.updateMetadata({
      title: 'Sencha Tea - True Teas for Masters',
      image: '/assets/tea-type-lady/green-tea-lady.png',
    });
  }
}
